<template>
  <vx-card card-background="#3b3a3d" title="El proceso de onboarding ha sido completado." title-color="white" >
    <p class="text-white">
      La cuenta del inversionista está lista para que pueda abonar fondos y comenzar a invertir.
    </p>
  </vx-card>
</template>

<script>
export default {
  name: "FundReady"
}
</script>
